<template>
  <div>
    <!-- Navbar -->
    <nav class="navbar navbar-expand-lg navbar-transparent navbar-absolute fixed-top">
      <div class="container-fluid">
        <div class="navbar-wrapper">
          <a class="navbar-brand" href="javascript:;">
            <slot name="navbarname"></slot>
          </a>
        </div>
        <button class="navbar-toggler" type="button" data-toggle="collapse" aria-controls="navigation-index"
                aria-expanded="false" aria-label="Toggle navigation">
          <span class="sr-only">Toggle navigation</span>
          <span class="navbar-toggler-icon icon-bar"></span>
          <span class="navbar-toggler-icon icon-bar"></span>
          <span class="navbar-toggler-icon icon-bar"></span>
        </button>
        <div class="collapse navbar-collapse justify-content-end">
          <ul class="navbar-nav">
            <li class="nav-item dropdown">
              <a class="nav-link" href="javascript:;" id="navbarDropdownProfile" data-toggle="dropdown"
                 aria-haspopup="true" aria-expanded="false">
                <i class="material-icons">person</i>
                <p class="d-lg-none d-md-block">
                  Account
                </p>
              </a>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownProfile">
                <a @click.prevent="logout" class="dropdown-item" href="#">Log out</a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import Http from '../../Services/HttpService/HttpService'
import Notification from '../../Services/Notification/Nottification'
import axios from 'axios'

export default {
  name: "Navbar",
  methods: {
    logout() {
      this.$Progress.start();
      Http.get(Http.apiurl() + 'auth/logout')
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.ok()) {
              localStorage.removeItem('token');
              localStorage.removeItem('role');
              delete axios.defaults.headers.common['Authorization'];
              Notification.success(response.data.message);
              window.location = Http.addressImage();
            } else {
              Notification.error(response.data.message);

              this.$router.go({name: 'AuthLogin'})
            }
          })
          .catch((error) => {
            this.$Progress.finish();
          });

    },
  }
}
</script>

<style scoped>

</style>